import { getModuleDescription } from '../DataAndAPIs/ClassSections'
import { oreillyPlaylistSC } from '../DataAndAPIs/Links'
import { activitiesListIntro, closing, learningObjectivesIntro, standardActivitiesClosing, initialPost, estimated } from './AL00000Sprint00'
import { capstoneSprint4Link } from '../Activities/ClassProduct'

export const al49200Sprint04 = () => {
	const sprint = 4
	return ( <div>
		<h5>Sprint {sprint}: {getModuleDescription(sprint-1)}</h5>
		<p>Let’s keep it simple this sprint. Focus on adding new customers and delivering maximum value to those customers.</p>	

		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>
			<li>Master sprint planning</li>
			<li>Fully understand MVP while staying laser focused on implementing your MVP by the end of sprint {sprint}</li>
			<li>Master sprint reviews (demos), retrospectives, and done</li>
		</ul>

		{list49200Sprint04(sprint)}
		{closing(sprint)}
	</div> )
}

export const list49200Sprint04 = (sprint) => {
	return ( <div>
		{activitiesListIntro(sprint)}
		<ol>
			<li>Complete {capstoneSprint4Link()} Requirements 0, 1, and 2</li>

			<li>Within {oreillyPlaylistSC()} review and fully implement “Essential Scrum” chapters 19 through 22</li>
			{initialPost(sprint)}
			<li>Within {oreillyPlaylistSC()} rigorously read “Essential Scrum” chapters 14 through 18{estimated('2 hour')}</li>
			{standardActivitiesClosing(sprint, capstoneSprint4Link(),'14 hours per team member')} 
		</ol>
	</div> )
}

// Certified for FA26 on October, 4, 2026




